<div class="gv-home">
  <header class="gv-header" role="banner">
    <div class="gv-header__inner">
      <a class="gv-brand" (click)="scrollTo('top')" tabindex="0" aria-label="Green Village - início">
        <span class="gv-brand__logo">
          <img src="assets/logos/logo 150.png" alt="" aria-hidden="true">
        </span>
        <span class="gv-brand__name mat-headline-small">Green Village</span>
      </a>

      <nav class="gv-nav gv-nav--desktop" aria-label="Navegação principal">
        <a class="gv-nav__link" (click)="scrollTo('funcionalidades')" tabindex="0">Funcionalidades</a>
        <a class="gv-nav__link" (click)="scrollTo('como-funciona')" tabindex="0">Como funciona</a>
        <a class="gv-nav__link" (click)="scrollTo('planos')" tabindex="0">Planos</a>
        <a class="gv-nav__link" (click)="scrollTo('seguranca')" tabindex="0">Segurança</a>
      </nav>

      <div class="gv-header__actions">
        <button mat-stroked-button class="gv-btn gv-btn--ghost" (click)="onLogin()" aria-label="Entrar">
          Entrar
        </button>
        <button mat-flat-button class="gv-btn gv-btn--primary gv-header__cta" (click)="goToSignup()" aria-label="Teste grátis por 30 dias">
          Crie uma conta grátis
        </button>
        <button
          mat-icon-button
          class="gv-header__menu-toggle"
          (click)="toggleMobileMenu()"
          [attr.aria-expanded]="mobileMenuOpen"
          aria-label="Abrir menu"
          type="button">
          <mat-icon class="material-symbols-outlined">{{ mobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
        </button>
      </div>
    </div>

    <nav
      class="gv-mobile-menu"
      [class.gv-mobile-menu--open]="mobileMenuOpen"
      aria-label="Navegação principal mobile">
      <a class="gv-mobile-menu__link" (click)="scrollTo('funcionalidades')" tabindex="0">Funcionalidades</a>
      <a class="gv-mobile-menu__link" (click)="scrollTo('como-funciona')" tabindex="0">Como funciona</a>
      <a class="gv-mobile-menu__link" (click)="scrollTo('planos')" tabindex="0">Planos</a>
      <a class="gv-mobile-menu__link" (click)="scrollTo('seguranca')" tabindex="0">Segurança</a>
      <button mat-flat-button class="gv-btn gv-btn--primary gv-mobile-menu__cta" (click)="goToSignup()">
        Teste grátis por 30 dias
      </button>
    </nav>
  </header>

  <main class="gv-main" id="top">
    <section class="gv-section gv-hero" aria-labelledby="gv-hero-title">
      <div class="gv-section__inner gv-hero__inner">
        <div class="gv-hero__content">
          <h1 id="gv-hero-title" class="gv-hero__title mat-display-medium">
            A gestão do condomínio, simples e organizada
          </h1>
          <p class="gv-hero__lead mat-body-large">
            Centralize comunicados, tarefas agendadas e incidentes em um só lugar, com uma experiência prática para síndicos e equipes de gestão.
          </p>
          <div class="gv-hero__actions">
            <button mat-flat-button class="gv-btn gv-btn--primary gv-btn--lg" (click)="goToSignup()">
              Teste grátis por 30 dias
            </button>
            <button mat-stroked-button class="gv-btn gv-btn--secondary gv-btn--lg" (click)="scrollTo('planos')">
              Ver planos
            </button>
          </div>
          <ul class="gv-hero__bullets">
            <li>
              <mat-icon class="material-symbols-outlined" aria-hidden="true">check_circle</mat-icon>
              <span>Sem instalação</span>
            </li>
            <li>
              <mat-icon class="material-symbols-outlined" aria-hidden="true">check_circle</mat-icon>
              <span>Acesso pelo navegador</span>
            </li>
            <li>
              <mat-icon class="material-symbols-outlined" aria-hidden="true">check_circle</mat-icon>
              <span>30 dias grátis</span>
            </li>
          </ul>
        </div>

        <div class="gv-hero__preview" aria-hidden="true">
          <div class="gv-hero__preview-frame">
            <span class="gv-hero__preview-label">Preview do sistema</span>
            <img src="assets/home/screenshot-hero.png" alt="Preview do painel do Green Village">
          </div>
        </div>
      </div>
    </section>

    <section class="gv-section gv-section--soft" id="problemas" aria-labelledby="gv-problems-title">
      <div class="gv-section__inner">
        <h2 id="gv-problems-title" class="gv-section__title mat-headline-large">
          Problemas que o Green Village ajuda a resolver
        </h2>
        <div class="gv-grid gv-grid--3">
          <article class="gv-card">
            <div class="gv-card__icon" aria-hidden="true">
              <mat-icon class="material-symbols-outlined">forum</mat-icon>
            </div>
            <h3 class="mat-title-large">Comunicados dispersos</h3>
            <p class="mat-body-medium">Informações importantes se perdem em grupos e mensagens soltas.</p>
          </article>
          <article class="gv-card">
            <div class="gv-card__icon" aria-hidden="true">
              <mat-icon class="material-symbols-outlined">event_busy</mat-icon>
            </div>
            <h3 class="mat-title-large">Rotinas esquecidas</h3>
            <p class="mat-body-medium">Manutenções e tarefas recorrentes ficam sem acompanhamento.</p>
          </article>
          <article class="gv-card">
            <div class="gv-card__icon" aria-hidden="true">
              <mat-icon class="material-symbols-outlined">report_problem</mat-icon>
            </div>
            <h3 class="mat-title-large">Incidentes sem controle</h3>
            <p class="mat-body-medium">Ocorrências ficam espalhadas e difíceis de acompanhar até a resolução.</p>
          </article>
        </div>
      </div>
    </section>

    <section class="gv-section" id="como-funciona" aria-labelledby="gv-how-title">
      <div class="gv-section__inner">
        <h2 id="gv-how-title" class="gv-section__title mat-headline-large">Como funciona</h2>
        <ol class="gv-steps">
          <li class="gv-step">
            <span class="gv-step__index" aria-hidden="true">1</span>
            <h3 class="gv-step__title mat-title-large">1. Cadastre o condomínio</h3>
            <p class="gv-step__desc mat-body-medium">Preencha os dados do condomínio e convide sua equipe para começar.</p>
          </li>
          <li class="gv-step">
            <span class="gv-step__index" aria-hidden="true">2</span>
            <h3 class="gv-step__title mat-title-large">2. Organize tarefas, comunicados e incidentes</h3>
            <p class="gv-step__desc mat-body-medium">Registre e centralize as informações importantes do dia a dia em poucos cliques.</p>
          </li>
          <li class="gv-step">
            <span class="gv-step__index" aria-hidden="true">3</span>
            <h3 class="gv-step__title mat-title-large">3. Acompanhe tudo em um só lugar</h3>
            <p class="gv-step__desc mat-body-medium">Tenha visibilidade completa e tome decisões com mais agilidade e segurança.</p>
          </li>
        </ol>
      </div>
    </section>

    <section class="gv-section gv-section--soft" id="funcionalidades" aria-labelledby="gv-features-title">
      <div class="gv-section__inner">
        <h2 id="gv-features-title" class="gv-section__title mat-headline-large">Principais funcionalidades</h2>
        <div class="gv-grid gv-grid--2">
          <article class="gv-card gv-feature">
            <div class="gv-feature__icon" aria-hidden="true">
              <mat-icon class="material-symbols-outlined">calendar_month</mat-icon>
            </div>
            <div class="gv-feature__body">
              <h3 class="mat-title-large">Tarefas agendadas</h3>
              <p class="mat-body-medium">Planeje e acompanhe rotinas importantes do condomínio.</p>
            </div>
          </article>
          <article class="gv-card gv-feature">
            <div class="gv-feature__icon" aria-hidden="true">
              <mat-icon class="material-symbols-outlined">campaign</mat-icon>
            </div>
            <div class="gv-feature__body">
              <h3 class="mat-title-large">Comunicados</h3>
              <p class="mat-body-medium">Compartilhe avisos de forma centralizada e organizada.</p>
            </div>
          </article>
          <article class="gv-card gv-feature">
            <div class="gv-feature__icon" aria-hidden="true">
              <mat-icon class="material-symbols-outlined">warning</mat-icon>
            </div>
            <div class="gv-feature__body">
              <h3 class="mat-title-large">Gestão de incidentes</h3>
              <p class="mat-body-medium">Registre, acompanhe e conclua ocorrências com mais clareza.</p>
            </div>
          </article>
          <article class="gv-card gv-feature">
            <div class="gv-feature__icon" aria-hidden="true">
              <mat-icon class="material-symbols-outlined">grid_view</mat-icon>
            </div>
            <div class="gv-feature__body">
              <h3 class="mat-title-large">Visão centralizada</h3>
              <p class="mat-body-medium">Tenha mais controle da operação do dia a dia em uma única plataforma.</p>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="gv-section" id="planos" aria-labelledby="gv-plans-title">
      <div class="gv-section__inner">
        <h2 id="gv-plans-title" class="gv-section__title mat-headline-large">Planos</h2>
        <p class="gv-section__subtitle mat-body-large">Todos os planos incluem 30 dias grátis</p>

        <div class="gv-grid gv-grid--3 gv-plans">
          @for (plan of plans; track plan.id) {
            <article class="gv-card gv-plan" [class.gv-plan--featured]="plan.featured">
              @if (plan.featured) {
                <span class="gv-plan__badge">Mais escolhido</span>
              }
              <h3 class="gv-plan__name mat-title-large">{{ plan.name }}</h3>
              <p class="gv-plan__capacity mat-body-medium">{{ plan.capacity }}</p>
              <p class="gv-plan__price">
                <span class="gv-plan__price-value mat-headline-medium">{{ plan.price }}</span>
                <span class="gv-plan__price-period mat-body-medium">/ mês</span>
              </p>
              <ul class="gv-plan__features">
                @for (feature of plan.features; track feature) {
                  <li>
                    <mat-icon class="material-symbols-outlined" aria-hidden="true">check</mat-icon>
                    <span>{{ feature }}</span>
                  </li>
                }
              </ul>
              <button
                mat-flat-button
                class="gv-btn gv-btn--block"
                [class.gv-btn--primary]="plan.featured"
                [class.gv-btn--secondary]="!plan.featured"
                (click)="goToSignup()">
                Começar teste grátis
              </button>
            </article>
          }
        </div>
      </div>
    </section>

    <section class="gv-section gv-section--soft" id="seguranca" aria-labelledby="gv-security-title">
      <div class="gv-section__inner">
        <h2 id="gv-security-title" class="gv-section__title mat-headline-large">Segurança e confiança</h2>
        <div class="gv-grid gv-grid--3 gv-trust">
          <article class="gv-trust__item">
            <div class="gv-trust__icon" aria-hidden="true">
              <mat-icon class="material-symbols-outlined">lock</mat-icon>
            </div>
            <p class="mat-body-medium">Pagamento em ambiente seguro via Asaas</p>
          </article>
          <article class="gv-trust__item">
            <div class="gv-trust__icon" aria-hidden="true">
              <mat-icon class="material-symbols-outlined">cloud</mat-icon>
            </div>
            <p class="mat-body-medium">Acesso online sem necessidade de instalação</p>
          </article>
          <article class="gv-trust__item">
            <div class="gv-trust__icon" aria-hidden="true">
              <mat-icon class="material-symbols-outlined">verified</mat-icon>
            </div>
            <p class="mat-body-medium">Experiência pensada para facilitar a rotina de gestão do condomínio</p>
          </article>
        </div>
      </div>
    </section>

    <section class="gv-section gv-final-cta" aria-labelledby="gv-final-cta-title">
      <div class="gv-section__inner gv-final-cta__inner">
        <h2 id="gv-final-cta-title" class="mat-headline-large">Pronto para organizar a gestão do seu condomínio?</h2>
        <p class="mat-body-large">Experimente o Green Village por 30 dias e escolha o plano ideal para sua realidade.</p>
        <div class="gv-final-cta__actions">
          <button mat-flat-button class="gv-btn gv-btn--primary gv-btn--lg" (click)="goToSignup()">
            Teste grátis por 30 dias
          </button>
          <button mat-stroked-button class="gv-btn gv-btn--secondary gv-btn--lg" (click)="onLogin()">
            Entrar
          </button>
        </div>
      </div>
    </section>
  </main>

  <footer class="gv-footer" role="contentinfo">
    <div class="gv-section__inner gv-footer__inner">
      <div class="gv-footer__brand">
        <span class="gv-brand__logo gv-brand__logo--footer">
          <img src="assets/logos/logo 150.png" alt="" aria-hidden="true">
        </span>
        <span class="mat-title-medium">Green Village</span>
      </div>
      <nav class="gv-footer__nav" aria-label="Rodapé">
        <a class="gv-footer__link" (click)="scrollTo('funcionalidades')" tabindex="0">Funcionalidades</a>
        <a class="gv-footer__link" (click)="scrollTo('planos')" tabindex="0">Planos</a>
        <a class="gv-footer__link" (click)="scrollTo('seguranca')" tabindex="0">Segurança</a>
        <a class="gv-footer__link" (click)="onLogin()" tabindex="0">Entrar</a>
      </nav>
      <span class="gv-footer__copy mat-body-small">© Green Village</span>
    </div>
  </footer>
</div>
